<script>
import Layout from '@layouts/main'
import lazyLoadComponent from '@router/lazyload-component'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxLeave } from '@utils/message-box'
import formatDate, { formatRequestData } from '@utils/format-date'

const periodTypeOption = [
  {
    title: '日',
    type: 'day',
  },
  {
    title: '月',
    type: 'month',
  },
  {
    title: '年',
    type: 'year',
  },
]
const initData = () => {
  return {
    title: '',
    state: 1,
    saleStartDate: null,
    saleEndDate: null,
    description: null,
    discountTyp: null,
    discount: {
      cosmetic: 0,
      daycare: 0,
      homestay: 0,
      prepaid: 0,
      deposit: 0,
    },
    services: [],
    deposits: [],
    prepaids: [],
    periodType: 'day',
    period: 0,
    basePrice: 0,
    price: 0,
    upgradeCondition: []
  }
}

export default {
  page: {
    title: '新增會員等級',
    meta: [{ name: 'description', content: 'Add MemberLevel' }],
  },
  components: {
    Layout,
    BaseSteps: () => import('@components/BaseSteps'),
    'MemberLevelSettingStep-1': () => lazyLoadComponent(import('./MemberLevelSettingStep1')),
    'MemberLevelSettingStep-2': () => lazyLoadComponent(import('./MemberLevelSettingStep2Service')),
    'MemberLevelSettingStep-3': () => lazyLoadComponent(import('./MemberLevelSettingStep2ServiceAddition')),
    'MemberLevelSettingStep-4': () => lazyLoadComponent(import('./MemberLevelSettingStep2Prepaid')),
    'MemberLevelSettingStep-5': () => lazyLoadComponent(import('./MemberLevelSettingStep2Deposit')),
  },
  filters: {
    formatDate,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  provide() {
    return {
      isEdit: false,
      dbData: this.defaultValue,
      userInputData: {},
    }
  },
  data() {
    return {
      submitData: Object.assign({}, initData(), this.defaultValue),
      tagList: [],
      tryingStore: false,
      periodTypeOption: [...periodTypeOption],
      activeStep: 1,
      stepList: Object.freeze([
        {
          title: '基本設定',
          key: 'basic',
        },
        {
          title: '美容服務折扣設定',
          key: 'service',
        },
        {
          title: '美容服務加購折扣設定',
          key: 'addition',
        },
        {
          title: '療程方案折扣設定',
          key: 'prepaid',
        },
        {
          title: '儲值點數折扣設定',
          key: 'deposit',
        },
      ]),
      tryingNextStep: false,
      userInputData: {
        service: [],
        'service-add': [],
        prepaid: [],
        deposit: [],
      },
    }
  },
  computed: {
    // submitData:{
    //   get(){
    //     return this.defaultValue
    //   },
    //   set(value) {
    //     this.$emit('update:defaultValue', value)
    //   },
    // },
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入等級方案名稱',
          },
        ],
        period: [
          {
            required: true,
            message: '請輸入天數',
          },
        ],
        description: [
          {
            required: true,
            message: '請輸入內容',
          },
        ],
        discount: {
          prepaid: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          cosmetic: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          deposit: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          daycare: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
          homestay: [
            {
              required: true,
              message: '折扣不能為空',
            },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: '請輸入小於 100 之數字',
            },
          ],
        },
      }
    },
    isEditMode() {
      return !!this.defaultValue.id
    },
    productBaseBookingUrl() {
      let url = ''
      if (window.globalData.APP_ENV === 'local') {
        url = this.merchantUrl
      } else {
        const prefixUrl = this.merchantUrl.split('//', 2)
        url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
      }
      return url
    },
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
  },
  mounted() {
    if (!this.$hasDeposit()) {
      this.stepList = this.stepList.filter((item) => item.key !== 'deposit')
    }
  },
  created() {},
  methods: {
    validate() {
      return this.$refs.step.$refs.form.validate()
    },
    async onClickLeave() {
      try {
        if (!this.isEditMode) {
          await messageBoxLeave('會員等級')
          this.$router.push({ name: 'member', params: { activeTab: '1', pagination: this.pagination, filterData: this.filterData } })
        }
        this.$router.push({ name: 'member', params: { activeTab: '1', pagination: this.pagination, filterData: this.filterData } })
      } catch (error) {
      } finally {
      }
    },
    async tryToStore() {
      try {
        this.tryingStore = true
        await this.$store.dispatch('memberLevel/store', this.submitData)
        messageStore('add')
        this.$router.push({ name: 'member', params: { activeTab: '1', pagination: this.pagination, filterData: this.filterData } })
      } catch (error) {
        // console.log(error)
      } finally {
        this.tryingStore = false
      }
    },
    onPeriodTypeChange() {},
    async onClickNextStep(step) {
      if (step === 1) {
        await this.validate()
      }

      if (step !== this.stepList.length) {
        this.activeStep += 1
      } else {
        this.tryToStore()
      }
    },
    backToList() {},
    back() {
      this.activeStep--
    },
    /**
     * @description 更新折扣資料
     */
    updateDiscountData(data) {
      if (data.submitData.length > 0 && data.submitData[0]) {
        this.userInputData[data.type] = data.submitData.filter((item) => item.discount > 0 || item.discountType === '%')
      }
      this.submitData['services'] = this.userInputData['service'].concat(this.userInputData['service-add'])
      this.submitData['deposits'] = this.userInputData['deposit']
      this.submitData['prepaids'] = this.userInputData['prepaid']
    },
    updateCondition(conditions) {
      // console.log(conditions)
      const conditionData = []

      if (conditions.length === 1 && (!conditions[0].type || !conditions[0].value)) {
        this.submitData.upgradeCondition = conditionData
        return
      }

      conditions.forEach((item) => {
        const { logic, condition, value } = item
        const data = {
          logic,
          type: condition,
          value,
        }
        conditionData.push(data)
      })
      this.submitData.upgradeCondition = conditionData
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.pageContent">
      <BaseSteps :active="activeStep" :list="stepList" />
      <el-card :class="$style['card-wrapper']" class="isStyleNormal">
        <keep-alive>
          <component :is="`MemberLevelSettingStep-${activeStep}`" ref="step" :default-value="submitData" @updateSubmitData="updateDiscountData" @updateCondition="updateCondition"></component>
        </keep-alive>
        <div :class="$style.footer">
          <el-button class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>
          <el-button v-if="activeStep !== 1" class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="back">上一步</el-button>
          <el-button
            class="is-round"
            data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
            type="primary"
            :loading="tryingNextStep"
            @click="onClickNextStep(activeStep)"
            >{{ activeStep !== 5 ? '下一步' : '完成' }}</el-button
          >
        </div>
      </el-card>
    </div>
  </Layout>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }

    .el-input-group__append {
      background-color: $color-line;
      border-radius: 0 5px 5px 0;
    }

    .el-input {
      &.isStyleText {
        .el-input-group__append {
          background: transparent;
          border-radius: 0;
          border-left: 0;
        }

        .el-input__inner {
          border-radius: 5px;
        }
      }
    }
  }
}

// %img-size {
//   width: calc(33.333333% - 10px);
//   height: 175px;
//   @include max-sm {
//     width: calc(100% - 10px);
//   }
// }
:global {
  //   :local(.upload) {
  //     margin: 0 -10px;
  //     border-top: none !important;
  //     > div {
  //       @extend %img-size;
  //     }

  //     .image-and-action {
  //       @extend %img-size;
  //       & + div {
  //         @extend %img-size;
  //       }
  //     }
  //   }
  // }
  // .form-item--split {
  //   display: flex;
  //   align-items: center;
  //   height: 40px;
  //   line-height: 40px;

  //   :global {
  //     .el-radio-group {
  //       flex-shrink: 0;
  //       margin-right: 15px;
  //     }
  //     .el-input {
  //       max-width: 150px;
  //     }
  //   }
  // }
}
</style>
